import React, { memo, useContext, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { TableCell as MuiTableCell } from '@material-ui/core';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import ListTableVariantContext from '../../../ListTableVariantContext';

export const getRowHeaderProps = ({ variant, isRowHeader }) =>
  variant === 'table' && isRowHeader
    ? {
        component: 'th',
        scope: 'row',
        role: 'rowheader'
      }
    : {};

const useStyles = makeStyles(() => ({
  tableCellFixed: {
    position: 'sticky',
    left: '0px'
  },
  tableCellLeftOfFixed: {
    // paddingLeft: '324px'
  }
}));

export const TableCell = ({
  classes: classesOverride,
  className,
  fixed,
  leftOfFixed,
  children,
  field,
  onCellClick,
  isRowHeader,
  ...rest
}) => {
  const classes = useStyles({ classes: classesOverride });
  const variant = useContext(ListTableVariantContext);

  const Component = variant === 'table' ? MuiTableCell : 'div';
  const rowHeaderProps = getRowHeaderProps({ variant, isRowHeader });

  const onClickHandler = useCallback(
    event => {
      onCellClick && onCellClick(event, field);
    },
    [field, onCellClick]
  );

  return (
    <Component
      onClick={onCellClick ? onClickHandler : undefined}
      className={classnames(
        classes.tableCell,
        fixed ? classes.tableCellFixed : undefined,
        leftOfFixed ? classes.tableCellLeftOfFixed : undefined,
        className
      )}
      {...rowHeaderProps}
      {...rest}
    >
      {children}
    </Component>
  );
};

TableCell.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  fixed: PropTypes.bool,
  leftOfFixed: PropTypes.bool,
  children: PropTypes.any,
  field: PropTypes.string,
  onCellClick: PropTypes.func,
  isRowHeader: PropTypes.bool
};

export default memo(TableCell);
